import { ReactElement } from 'react';
import { AbsoluteFill } from 'remotion';

// Components
import { ScrollingTileBackground } from '@/components/common/ScrollingTileBackground';
import { MainSection } from './components/MainSection';

// Types
import { EmployeeCertification } from '@/types';

interface Scene6Props {
  certificates?: EmployeeCertification[];
  totalCertificates?: number;
  animationDelay?: number;
}

export const Scene6 = ({
  certificates = [],
  totalCertificates = 0,
  animationDelay = 0,
}: Scene6Props): ReactElement => {
  return (
    <AbsoluteFill className="overflow-hidden">
      <MainSection
        certificates={certificates}
        totalCertificates={totalCertificates}
        animationDelay={animationDelay}
      />

      {/* Infinite scrolling checkerboard background */}
      <ScrollingTileBackground />
    </AbsoluteFill>
  );
};
